import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18l0 -3","key":"svg-0"}],["path",{"d":"M10 18l0 -6","key":"svg-1"}],["path",{"d":"M14 18l0 -9","key":"svg-2"}],["path",{"d":"M18 18l0 -12","key":"svg-3"}]]

const IconAntennaBars5 = createReactComponent('outline', 'antenna-bars-5', 'AntennaBars5', __iconNode);

export default IconAntennaBars5;